/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PlayerCell } from './PlayerCell';
import { RankCell } from './RankCell';
import { getRanks } from '../utils/get-ranks';
import { useSelector } from 'react-redux';
import { BENCHMARKING } from '../../config/benchmarking';
import { statsLeadersBenchmarkingSelector, statsLeadersSortSelector } from '../../../../../../store/js/modules/statspro/stats-leaders/selectors';

/**
 * @param {object} props - Props.
 * @param {object[]} props.page - Rows to render.
 * @param {Function} props.getTableBodyProps - Get table body props function.
 * @param {Function} props.prepareRow - Prepare row function.
 * @param {object[]} props.preFilteredRows - All rows before filtering has been applied.
 * @param {object[]} props.players - TODO:
 * @returns {JSX.Element} Component.
 */
export const TableBody = ( {
    page,
    getTableBodyProps,
    prepareRow,
    preFilteredRows,
    players
} ) => {

    const sort = useSelector( statsLeadersSortSelector );
    const benchmarking = useSelector( statsLeadersBenchmarkingSelector );
    
    const sortedPreFilteredRowsDesc = preFilteredRows.sort( ( a, b ) =>
        a.values[ sort.columnId ] > b.values[ sort.columnId ] ? -1 : 1
    );

    const ranks = getRanks( sortedPreFilteredRowsDesc, sort.columnId );

    return (
        <tbody { ...getTableBodyProps() }>
            { page.map(
                row => {
                    const rank = ranks[ row.id ];
                    prepareRow( row );

                    return (
                        <tr
                            { ...row.getRowProps() }
                            className="stats-leaders-table__body-row"
                        >
                            { row.cells.filter( cell => ![ 'position', 'team' ].includes( cell.column.id ) ).map( cell => {
                                const cellProps = cell.getCellProps();

                                if ( cell.column.id === 'rank' ) {
                                    return (
                                        <RankCell
                                            { ...cellProps }
                                            rank={ rank }
                                        />
                                    );
                                }
                                if ( cell.column.id === 'player' ) {
                                    return (
                                        <PlayerCell
                                            { ...cellProps }
                                            player={ cell.value }
                                            rank={ rank }
                                        />
                                    );
                                }

                                let benchmarkValue = { benchmark: null };

                                if ( benchmarking.isActive ) {
                                    const player = players.find( p =>
                                        p.details.playerId === row.original.player.playerId
                                    );

                                    if ( player.stats.benchmarkedTotals ) {
                                        benchmarkValue = player.stats.benchmarkedTotals[ cell.column.id ];
                                    }
                                }

                                return (
                                    <td
                                        { ...cellProps }
                                        className={ classnames( 'stats-leaders-table__cell', {
                                            'stats-leaders-table__cell--sorted': cell.column.isSorted,
                                            'stats-leaders-table__cell--elite': benchmarkValue.benchmark === BENCHMARKING.ELITE.KEY,
                                            'stats-leaders-table__cell--above-avg': benchmarkValue.benchmark === BENCHMARKING.ABOVE_AVERAGE.KEY,
                                            'stats-leaders-table__cell--avg': benchmarkValue.benchmark === BENCHMARKING.AVERAGE.KEY,
                                            'stats-leaders-table__cell--below-avg': benchmarkValue.benchmark === BENCHMARKING.BELOW_AVERAGE.KEY,
                                        } ) }
                                    >
                                        { cell.render( 'Cell' ) }
                                    </td>
                                );
                            } ) }
                        </tr>
                    );
                }
            ) }
        </tbody>
    );
};

TableBody.propTypes = {
    page: PropTypes.array.isRequired,
    getTableBodyProps: PropTypes.func.isRequired,
    prepareRow: PropTypes.func.isRequired,
    preFilteredRows: PropTypes.array.isRequired,
    players: PropTypes.array.isRequired,
};